// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__YffAK","header":"About_header__vwd37","goBack":"About_goBack__4Bz6F","container":"About_container__b6WV-"};